<button class="btn btn-secondary btn-sm mb-2 ng-tns-c242-28" (click)="back()">
  <i _ngcontent-dspace-angular-c242="" class="fas fa-arrow-left ng-tns-c242-3"></i>
  {{this.buttonLabel | async}}
</button>

